import ReactECharts from "echarts-for-react";

export default function BarCharts({
  color,
  line,
  xaxisdata,
  yaxisdata,
  linedata,
  heading,
  headingColor,
  headingFont,
}) {
  const options = {
    title: {
      text: heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: headingFont,
        fontWeight: "600",
        color: headingColor,
      },
    },
    color: [color],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: xaxisdata,
      axisTick: {
        show: true,
        alignWithLabel: true,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        interval: "auto",
        rotate: 45,
        formatter: function (value) {
          const maxLength = 6;
          return value.length > maxLength
            ? value.slice(0, maxLength) + "..."
            : value;
        },
        width: 100,
        boundaryGap: true,
      },
    },
    yAxis: {
      type: "value",
      splitLine: {
        show: false,
        lineStyle: {
          color: "rgba(200, 200, 200, 1)",
          width: 0.5,
          type: "dotted",
        },
      },
    },
    series: [
      {
        data: yaxisdata,
        type: "bar",
        itemStyle: {
          barBorderRadius: [10, 10, 0, 0],
        },
        label: {
          show: true,
          position: "top",
        },
        barWidth: "20%",
        barCategoryGap: "20%",
        barGap: "20%",
      },
      line && {
        data: linedata,
        type: "line",
        color: "#F8AE57",
      },
    ].filter(Boolean),
  };

  if (xaxisdata.length > 6) {
    options.dataZoom = [
      {
        type: "slider",
        show: true,
        startValue: 0,
        endValue: Math.min(5, xaxisdata.length - 1),
        handleSize: "5%",
        showDetail: false,
        zoomLock: true,
        bottom: 10,
        height: 10,
        fillerColor: "#2A5775",
        backgroundColor: "#ccc",
        handleColor: "#2A5775",
        zoomOnMouseWheel: false,
        moveOnMouseMove: false,
        moveOnMouseWheel: false,
      },
    ];
  }

  return <ReactECharts option={options} style={{ height: 220 }} />;
}
